<template>

    <div class="d-flex flex-row  align-items-center px-2" :class="{ 'flex-row' : true }" v-if="icons_type == 'hands'">
        <i class=" fa-thumbs-down btn text-danger  px-2" @click="rate('unlike')"
           :class="icon('unlike')"></i>
        <span>{{ new_difference ?? difference  }}</span>
        <i class=" fa-thumbs-up btn text-success  px-2" @click="rate('like')"
           :class="icon('like')"></i>
    </div>

    <div class="d-flex flex-column align-items-center px-2" v-else>
        <i class=" fa-thumbs-up btn text-success py-1" @click="rate('like')"
           :class="icon('like')"
           ></i>
        <span>{{ new_difference ??  difference  }}</span>
        <i class=" fa-thumbs-down btn text-danger py-1" @click="rate('unlike')"
           :class="icon('unlike')"></i>
    </div>


</template>

<script>
import { useToast } from "vue-toastification";
import axios from "axios";

const toast = useToast();

export default {
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        type: {
            type: String,
            required: true
        },
        icons_type: {
            type: String,
        },
        // likes : {
        //     type: Array,
        //     default: []
        // },
        user_like : {
            type: Object,
            default: {}
        },
        difference :{
            type: Number,
            default: 0
        }
    },
    data(){
        return {
            new_difference : null
        }
    },
    methods: {
        icon(type){
            return this.user_like?.action === type ? 'fa-solid' : 'fa-regular';
        },
        foundLike() {
            return Object.keys(this.user_like ?? {}).length > 0;
        },
        link(direction) {
            return direction === 'like' ? '/like' : '/unlike';
        },
        _delete() {
            const  that = this;

            axios.delete( `/like/${this.user_like?.id}` , {
                data: {
                    'subscribe_id': this.$route?.params?.subscribe_id
                }
            })
                .then(response => {
                    // toast.success(response.data.message, {
                    //     timeout: 3000,
                    // }, { icon: 'fa-solid fa-circle-check' });
                    that.$emit('update:user_like', null);
                    that.new_difference = response.data?.data?.difference;
                })
                .catch(error => {
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, { icon: 'fa-solid fa-circle-exclamation' });
                });
        },
        rate(direction) {
            console.log(this.foundLike());
            console.log(direction);
            console.log(this.user_like?.action);
            (
                this.foundLike()  // لو اصلا عامل لايك او داون لايك
                &&
                direction === this.user_like?.action
            )
                ? this._delete() : this._post(direction);
        },
        _post(direction) {
            // const id = toast.info('Processing...', { icon: 'fa-solid fa-spinner' });
            const  that = this;

            axios.post( this.link(direction) , {
                'item_id' : this.id ,
                'type' : this.type,
                'subscribe_id': this.$route?.params?.subscribe_id
            })
                .then(response => {
                    // console.log(response.data.data);
                    // that.user_like = response.data.data;
                    that.$emit('update:user_like', response.data.data);
                    that.new_difference = response.data?.data?.difference;

                    // toast.dismiss(id);
                    // toast.success(response.data.message, {
                    //     timeout: 3000,
                    // }, { icon: 'fa-solid fa-circle-check' });
                })
                .catch(error => {
                    console.log(error);
                    toast.dismiss(id);
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, { icon: 'fa-solid fa-circle-exclamation' });
                });
        }
    }
};
</script>

<style scoped>
.btn {
    cursor: pointer;
}
</style>
